//------------------
// NPM libarys 
//------------------


//------------------
// Helpers
//------------------

// Attach the scroll event listener
window.addEventListener('scroll', handleScroll);

function bild_ajax_load(){

    var links = document.querySelectorAll('a');
    for (let a = 0; a < links.length; a++) {
       let elm = links[a];

        if(isInternalLink(elm) && !elm.classList.contains('bound')){
            elm.classList.add('bound');
            elm.addEventListener('click', load_content);
        }
        
    }

}

function isInternalLink(link) {
   
  var currentHostname = window.location.hostname;
    var linkHostname = getHostnameFromHref(link.href);
  
    // Compare the hostnames
    return currentHostname === linkHostname;
  }

  function getHostnameFromHref(href) {

    if(href){
    var url = new URL(href);
    return url.hostname;
    }else{
        return false;
    }
  }


function load_content(e){
    e.preventDefault();

    let elm = this;

    var cur = document.querySelector('.content');
    var parent = cur.parentNode;

    document.body.classList.remove('playing-started');
    document.body.classList.remove('show-controls');
    document.body.classList.remove('playlist-hover');
    document.body.classList.remove('dark');
    window.killTimer = true;

    cur.style.filter = "blur(10px)";
    cur.style.opacity = 0;

    let newUrl = elm.href;
   
    let path = getUrlPathFromHref(newUrl);
    let blur = true;
    if(path === '/' || path === '/directors'){
        blur = false;
    }

    if(path.includes("/video")){
      document.body.style.background = '#000';
    }else{
      document.body.style.background = 'unset';
    }

    window.history.pushState({}, '', path);

    fetch(elm.href)
    .then(function(response) {
      return response.text();
    })
    .then(function(data) {

        
        window.scrollTo(0, 0);
        
        let html =  extractInnerContent(data);
        let content = html.querySelector('.content');

        if(blur){
            content.style.filter = "blur(10px)";
        }
        content.style.opacity = 0;
        
        cur.parentNode.removeChild(cur);
        parent.append(content);

        setTimeout(function(){
            
            if(blur){
                content.style.filter = "blur(0px)";
                setTimeout(function(){
                  content.style.filter = 'unset';
                });
            }

            content.style.opacity = 1;

        }, 50);

        page_load();
        
    })
    .catch(function(error) {
      console.error('Error:', error);
    });
}


function extractInnerContent(htmlString) {
    var tempElement = document.createElement('div');
    tempElement.innerHTML = htmlString;
    return tempElement;
  }

  function getUrlPathFromHref(href) {
    var link = document.createElement('a');
    link.href = href;

    return link.pathname;
 
  }


const nav = document.querySelector('nav');
const navLinks = nav.querySelectorAll('a');

function updateActive(){
  for (let a = 0; a < navLinks.length; a++) {
    
    if(navLinks[a].href === window.location.href){
      navLinks[a].classList.add('active-link');
    }else{
      navLinks[a].classList.remove('active-link');
    }
    
  }
}


//------------------
// Components 
//------------------

import start_swiper from './components/swipers.js';
import expand from './components/expaning-content.js';
import video from './components/video.js';
import thumb_player from './components/video-thumbs.js';
import swiper_player from './components/video-swipers.js';
import home_player from './components/home-thumbs.js';
import menu from './components/menu.js';
import directors_list from './components/directors_list.js';
import contact from './components/contact.js';


//------------------
// APP 
//------------------


function page_load(){

    if( getUrlPathFromHref(window.location.href) !== '/home_alt'){
      document.querySelector('header').classList.add('reg-pos');
    }

    if(document.querySelector('.homepage-swiper-alt')){
      shuffle_films();
    }

    swiper_player();
    bild_ajax_load();
    video();
    expand();
    menu();
    directors_list();
    start_swiper();
    thumb_player();
    home_player();
    contact();
    updateActive();

  setTimeout(function(){
    if(header.classList.contains('landing-pos')){
        header.classList.add('scrolled');
        header.classList.remove('landing-pos');
        header.classList.add('reg-pos');
        setTimeout(function(){
          header.classList.add('visable');
        }, 500);
        document.querySelector('.large-logo').style.opacity = 0;
    }
  }, 5000);

  setTimeout(function(){
    let gridTitles = document.querySelector('.grid-title');
    if(gridTitles){
      gridTitles.classList.add('stuck');
    }
  }, 2000);
};

page_load();

window.addEventListener('popstate', function(event) {
  location.reload(true);
});


  // Variables to store previous scroll position and header visibility
let prevScrollPos = window.pageYOffset;
let headerVisible = false;
let header = document.querySelector('header');

function shuffle_films(){

  let parent = document.querySelector('.homepage-swiper-alt');
  if(parent){
    let children = Array.from(parent.querySelectorAll('.full'));

    const shuffledElements = shuffleArray(children);

    shuffledElements.forEach((element) => {
      parent.prepend(element);
    });

    function shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    }
  }

};


// Function to handle scroll event
function handleScroll() {

  const currentScrollPos = window.pageYOffset;

  if(header.classList.contains('landing-pos')){

    if(currentScrollPos > window.innerHeight/2){
      header.classList.add('scrolled');
      header.classList.remove('landing-pos');
      header.classList.add('reg-pos');
      document.querySelector('.large-logo').style.opacity = 0;
    }else{
      header.classList.remove('scrolled');
    }
  

  }else{
 
   if(document.querySelector('.homepage')){
   
      
      if(currentScrollPos > window.outerHeight * 1.4){
        header.classList.add('scrolled');
      }else{
        header.classList.remove('scrolled');
      }
      
    }else{

      if(currentScrollPos > header.offsetHeight){
        header.classList.add('scrolled');
      }else{
        header.classList.remove('scrolled');
      }
    }
  

  }

  
  // Check if scrolling direction has changed
  if (currentScrollPos > prevScrollPos && headerVisible) {
    // Scrolling down, hide the header
    headerVisible = false;
    header.classList.remove('visable');
    // Code to hide the header goes here
  } else if (currentScrollPos < prevScrollPos && !headerVisible) {
    // Scrolling up, show the header
    headerVisible = true;
    header.classList.add('visable');
    // Code to show the header goes here
  }

  prevScrollPos = currentScrollPos;

  let gridTitles = document.querySelectorAll('.grid-title');
  for (let a = 0; a < gridTitles.length; a++) {
    const element = gridTitles[a];

    let stuck = isElementStuck(element, a);

    if(stuck){
      element.classList.add('stuck');
    }else{
      element.classList.remove('stuck');
    }
    
  }
}



document.addEventListener('mousemove', function(e){
  if(e.clientY < 100 && prevScrollPos > 80){
    header.classList.add('visable');
  }
});





function isElementStuck(element, a) {


  const computedStyle = getComputedStyle(element);
  const isSticky = computedStyle.position === 'sticky';

  if (!isSticky) {
      return false;
  }

  const rect = element.getBoundingClientRect();
  const offsetTop = parseInt(computedStyle.top, 10);

  // if(a && a==1){
  //   console.log(offsetTop, Math.floor(rect.top));
  // }


  // if(rect.top <= offsetTop && rect.top > 0){
  if(offsetTop <= Math.floor(rect.top) + 60 && offsetTop >= Math.floor(rect.top) - 60){
    return true;
  }else{
    return false;
  }
}



function isScrollAtBottom() {
    // Get the total height of the content
  const totalHeight = document.body.scrollHeight;
  const scrollPosition = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

  return scrollPosition >= totalHeight - (viewportHeight + 5);
}